import { DefaultService } from '@/services/DefaultService';


export default class AssAtendimentoFormularioService extends DefaultService {

    findAll(column, order, page, limit, situacao, uuid, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/formulario/assformularioatendimento.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&uuid=${uuid}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    updateSituacao(assAtendimentoFormulario) {
        return this._http.post(`${this._env}/ven/atendimento/assformularioatendimento/updatesituacao`, assAtendimentoFormulario, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findFormulariosNaoAssociados(column, order, page, limit, uuid, idPermTela, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/atendimento/assformularioatendimento/formulariosnaoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&uuid=${uuid}&idpermtela=${idPermTela}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    save(assAtendimentoFormulario) {
        return this._http.post(`${this._env}/ven/atendimento/assformularioatendimento`, assAtendimentoFormulario, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}